import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {CampaignSetupAgentToolName} from '../../campaignSetupAgent.enums';
import {conditionCardSchema} from '../../schemas/conditionCardSchema';
import addOrUpdateCardTool from '../general/addOrUpdateCardTool/addOrUpdateCardTool';
import getConditionSignalTool from './tools/getConditionSignalTool/getConditionSignalTool';
import searchFeedValuesTool from './tools/searchFeedValuesTool/searchFeedValuesTool';
import getFilesTool from 'common/src/modules/shared/copilot/tools/getFilesTool';
import readValuesFromExcelTool from '../general/readValuesFromExcelTool/readValuesFromExcelTool';

const cardSpecificInstructions = `1. Use the ${CampaignSetupAgentToolName.GetConditionSignal} tool to find the best matching signal for matching the user's request.
1.1. The tool will return the signal's key and type, use the type to determine the condKeyType in the condition card schema.
1.2. The tool will return the signal's shouldQueryOptionalValues property. If this is true and you are adding/editing condition outputs values, you MUST use the ${CampaignSetupAgentToolName.SearchFeedValues} tool to find the different values that are relevant for the signal. Provide the tool the 'signalKey' property (NOT the name) retrieved from the ${CampaignSetupAgentToolName.GetConditionSignal} tool.
1.3. The tool will return categories for the signal, use the categories to determine the categories in the condition card schema.
1.4. The tool will return the signal's optional operators, use the optional operators to determine the condOperator in the condition card schema.
2. When settings the outputs, maintain the existing values, unless the condition has been changed or the user has requested to change the outputs values.
3. When asked to remove an output, mainatain all other outputs and remove the requested output.`;

export default function addOrUpdateConditionCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.CONDITION,
    cardSchema: conditionCardSchema,
    tools: [
      getConditionSignalTool(store),
      searchFeedValuesTool(),
      getFilesTool(),
      readValuesFromExcelTool(),
    ],
    cardSpecificInstructions,
    description: `Add or update a condition card. Capable of searching feed column values and values from an excel file`,
  });
}
